import React from 'react';
import Stack from '../../Stack';
import { useIsMobileLayout } from '../../../../hooks/useIsMobileLayout';
import IconButton from '../../IconButton';
import Text from '../../Text';
import PressableDynamicOpacity from '../../PressableDynamicOpacity';

export type BaseScanHeaderOwnProps = {
    display: string;
    onPreviousPress: () => void;
    onNextPress: () => void;
    onDisplayPress?: () => void;
};

export type BaseScanHeaderProps = BaseScanHeaderOwnProps;

const BaseScanHeader: React.FC<BaseScanHeaderProps> = (props) => {
    const isMobile = useIsMobileLayout();
    return (
        <Stack
            horizontal
            justify={isMobile ? 'space-between' : 'center'}
            align="center"
            style={{ alignSelf: 'stretch', paddingTop: 2, paddingBottom: 4 }}
            space={4}
            padding={4}
        >
            <IconButton
                variant="large-transparent"
                icon="ChevronLeft"
                onPress={props.onPreviousPress}
                testID="calendar-scan-previous"
            />
            <PressableDynamicOpacity
                onPress={props.onDisplayPress || (() => {})}
                makePressable={!!props.onDisplayPress}
                testID="calendar-scan-header-display"
            >
                <Text
                    variant="h4"
                    alignText="center"
                    style={{
                        width: isMobile ? undefined : 160,
                    }}
                >
                    {props.display}
                </Text>
            </PressableDynamicOpacity>
            <IconButton
                variant="large-transparent"
                icon="ChevronRight"
                onPress={props.onNextPress}
                testID="calendar-scan-next"
            />
        </Stack>
    );
};

export default React.memo(BaseScanHeader);
